import React from "react";
import { ZOOM_ATTENDANCE_CONSTANTS } from "../../constants/ZoomAttendance.constants";
import {
  SessionColumn,
  StatusColumn,
  TotalAttendanceRing,
  AttendanceTypeCount,
  ViewAttendeesAction,
} from "./components/ListingMeetingDetailsTableComponents";
import {
  AttendanceRangeFilterInput,
  AttendanceCountRangeFilterInput,
} from "./components/AttendanceRangeFilterInput";

export const getMeetingDetailsColumnConfig = ({ onViewAttendees }) => [
  {
    field: ZOOM_ATTENDANCE_CONSTANTS.FIELDS.SESSION_NUMBER,
    headerName: ZOOM_ATTENDANCE_CONSTANTS.LABELS.SESSION,
    fixed: "left",
    width: ZOOM_ATTENDANCE_CONSTANTS.WIDTHS.WIDTH_150PX,
    renderColumn: (record) => <SessionColumn record={record} />,
    valueFormatter: (record) => <SessionColumn record={record} />,
  },
  {
    field: ZOOM_ATTENDANCE_CONSTANTS.FIELDS.STATUS,
    headerName: ZOOM_ATTENDANCE_CONSTANTS.LABELS.STATUS,
    renderColumn: (record) => <StatusColumn record={record} />,
    valueFormatter: (record) => <StatusColumn record={record} />,
  },
  {
    field: ZOOM_ATTENDANCE_CONSTANTS.FIELDS.TOTAL_UNIQUE_CUSTOMERS,
    headerName: ZOOM_ATTENDANCE_CONSTANTS.LABELS.BOOKED_ATTENDEES,
    valueFormatter: (record) =>
      record[ZOOM_ATTENDANCE_CONSTANTS.FIELDS.TOTAL_UNIQUE_CUSTOMERS],
  },
  {
    field: ZOOM_ATTENDANCE_CONSTANTS.FIELDS.ATTENDANCE_PERCENTAGE,
    headerName: ZOOM_ATTENDANCE_CONSTANTS.LABELS.TOTAL_ATTENDANCE,
    valueFormatter: (record) => <TotalAttendanceRing record={record} />,
  },
  {
    field: ZOOM_ATTENDANCE_CONSTANTS.FIELDS.FULL_ATTENDANCE,
    headerName: ZOOM_ATTENDANCE_CONSTANTS.LABELS.FULL,
    valueFormatter: (record) => (
      <AttendanceTypeCount
        record={record}
        field={ZOOM_ATTENDANCE_CONSTANTS.FIELDS.FULL_ATTENDANCE}
        textClass="tw-text-emerald-600"
      />
    ),
  },
  {
    field: ZOOM_ATTENDANCE_CONSTANTS.FIELDS.PARTIAL_ATTENDANCE,
    headerName: ZOOM_ATTENDANCE_CONSTANTS.LABELS.PARTIAL,
    valueFormatter: (record) => (
      <AttendanceTypeCount
        record={record}
        field={ZOOM_ATTENDANCE_CONSTANTS.FIELDS.PARTIAL_ATTENDANCE}
        textClass="tw-text-amber-600"
      />
    ),
  },
  {
    field: ZOOM_ATTENDANCE_CONSTANTS.FIELDS.ABSENT,
    headerName: ZOOM_ATTENDANCE_CONSTANTS.LABELS.ABSENT,
    valueFormatter: (record) => (
      <AttendanceTypeCount
        record={record}
        field={ZOOM_ATTENDANCE_CONSTANTS.FIELDS.ABSENT}
        textClass="tw-text-rose-600"
      />
    ),
  },
  {
    field: ZOOM_ATTENDANCE_CONSTANTS.FIELDS.UNRECOGNIZED,
    headerName: ZOOM_ATTENDANCE_CONSTANTS.LABELS.UNRECOGNIZED,
    valueFormatter: (record) => {
      if (
        record.status !== ZOOM_ATTENDANCE_CONSTANTS.ATTENDANCE_STATUS.COMPLETED
      ) {
        return ZOOM_ATTENDANCE_CONSTANTS.LABELS.NO_DATA;
      }
      return record[ZOOM_ATTENDANCE_CONSTANTS.FIELDS.UNRECOGNIZED];
    },
  },
  {
    field: ZOOM_ATTENDANCE_CONSTANTS.NUMERIC.EMPTY_STRING,
    headerName: ZOOM_ATTENDANCE_CONSTANTS.LABELS.ACTION,
    width: ZOOM_ATTENDANCE_CONSTANTS.WIDTHS.WIDTH_120PX,
    valueFormatter: (record) => (
      <ViewAttendeesAction record={record} onViewAttendees={onViewAttendees} />
    ),
    sortable: false,
    fixed: "right",
  },
];

export const filterConfig = [
  {
    source: ZOOM_ATTENDANCE_CONSTANTS.FILTERS.SOURCE_SESSION,
    placeholder: ZOOM_ATTENDANCE_CONSTANTS.FILTERS.SESSION_PLACEHOLDER,
    type: "input",
    disableContains: true,
  },
  {
    source: ZOOM_ATTENDANCE_CONSTANTS.FILTERS.SOURCE_STATUS,
    placeholder: ZOOM_ATTENDANCE_CONSTANTS.FILTERS.STATUS_PLACEHOLDER,
    type: "dropdown",
    options: [
      {
        value: ZOOM_ATTENDANCE_CONSTANTS.ATTENDANCE_STATUS.COMPLETED,
        label: ZOOM_ATTENDANCE_CONSTANTS.LABELS.COMPLETED,
      },
      {
        value: ZOOM_ATTENDANCE_CONSTANTS.ATTENDANCE_STATUS.UPCOMING,
        label: ZOOM_ATTENDANCE_CONSTANTS.LABELS.UPCOMING,
      },
    ],
  },
  {
    source: ZOOM_ATTENDANCE_CONSTANTS.FILTERS.SOURCE_TOTAL_ATTENDANCE,
    placeholder: ZOOM_ATTENDANCE_CONSTANTS.LABELS.TOTAL_ATTENDANCE_COUNT,
    type: "custom",
    render: (props) => <AttendanceCountRangeFilterInput {...props} />,
  },
  {
    source:
      ZOOM_ATTENDANCE_CONSTANTS.FILTERS.SOURCE_TOTAL_ATTENDANCE_PERCENTAGE,
    placeholder: ZOOM_ATTENDANCE_CONSTANTS.LABELS.TOTAL_ATTENDANCE_PERCENT,
    type: "custom",
    render: (props) => <AttendanceRangeFilterInput {...props} />,
  },
];

export const tableChipsFormatter = (
  filter,
  value,
  selectedFilter,
  filterValues = {}
) => {
  switch (filter) {
    case ZOOM_ATTENDANCE_CONSTANTS.FILTERS.SOURCE_SESSION:
      return `${ZOOM_ATTENDANCE_CONSTANTS.LABELS.SESSION}: ${value}`;
    case ZOOM_ATTENDANCE_CONSTANTS.FILTERS.SOURCE_STATUS:
      return `${ZOOM_ATTENDANCE_CONSTANTS.LABELS.STATUS}: ${value}`;
    case ZOOM_ATTENDANCE_CONSTANTS.FILTERS.SOURCE_TOTAL_ATTENDED_FROM: {
      const fromVal = value;
      const toVal =
        filterValues[
          ZOOM_ATTENDANCE_CONSTANTS.FILTERS.SOURCE_TOTAL_ATTENDED_TO
        ];
      if (toVal !== undefined && toVal !== null && toVal !== "") {
        return `${ZOOM_ATTENDANCE_CONSTANTS.LABELS.TOTAL_ATTENDANCE_COUNT}: From ${fromVal} - to ${toVal}`;
      }
      return `${ZOOM_ATTENDANCE_CONSTANTS.LABELS.TOTAL_ATTENDANCE_COUNT} From: ${fromVal}`;
    }
    case ZOOM_ATTENDANCE_CONSTANTS.FILTERS.SOURCE_TOTAL_ATTENDED_TO: {
      const fromVal =
        filterValues[
          ZOOM_ATTENDANCE_CONSTANTS.FILTERS.SOURCE_TOTAL_ATTENDED_FROM
        ];
      if (fromVal !== undefined && fromVal !== null && fromVal !== "") {
        return null;
      }
      return `${ZOOM_ATTENDANCE_CONSTANTS.LABELS.TOTAL_ATTENDANCE_COUNT} To: ${value}`;
    }
    case ZOOM_ATTENDANCE_CONSTANTS.FILTERS.SOURCE_ATTENDANCE_FROM: {
      const fromVal = value;
      const toVal =
        filterValues[ZOOM_ATTENDANCE_CONSTANTS.FILTERS.SOURCE_ATTENDANCE_TO];
      if (toVal !== undefined && toVal !== null && toVal !== "") {
        return `${ZOOM_ATTENDANCE_CONSTANTS.LABELS.TOTAL_ATTENDANCE_PERCENT}: From ${fromVal} - to ${toVal}`;
      }
      return `${ZOOM_ATTENDANCE_CONSTANTS.LABELS.TOTAL_ATTENDANCE_PERCENT} From: ${fromVal}`;
    }
    case ZOOM_ATTENDANCE_CONSTANTS.FILTERS.SOURCE_ATTENDANCE_TO: {
      const fromVal =
        filterValues[ZOOM_ATTENDANCE_CONSTANTS.FILTERS.SOURCE_ATTENDANCE_FROM];
      if (fromVal !== undefined && fromVal !== null && fromVal !== "") {
        return null;
      }
      return `${ZOOM_ATTENDANCE_CONSTANTS.LABELS.TOTAL_ATTENDANCE_PERCENT} To: ${value}`;
    }
    case ZOOM_ATTENDANCE_CONSTANTS.FILTERS.SOURCE_TOTAL_ATTENDANCE:
    case ZOOM_ATTENDANCE_CONSTANTS.FILTERS.SOURCE_TOTAL_ATTENDANCE_PERCENTAGE:
      return null;
    default:
      return filter;
  }
};
